import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Button,
  Stack,
} from "@mui/material";

import coin from "../Assets/Img/coin.svg";
import DummyImg from "../Assets/Img/Banner.jpg";
import Savedark from "../Assets/Img/Savedark.svg";
import Saveicon from "../Assets/Img/Saveicon.png";
import { Calendar } from "lucide-react";
import axiosMain from "../http/axiosMain";

const CampaignCard = ({
  ele,
  savedCampaigns,
  handleSaveCampaign,
  formatSingleDate,
  onUnlockCampaign,
  fetchData,
}) => {
  console.log(ele, "fetchData");
  const handleUnlockClick = async () => {
    // Set dynamic coin value based on budget
    let unlockAmount = 0; // default
    if (ele?.budget > 500000) {
      unlockAmount = 500;
    } else if (ele?.budget > 300000) {
      unlockAmount = 200;
    } else if (ele?.budget > 100000) {
      unlockAmount = 100;
    }

    try {
      const response = await axiosMain.post(
        "/api/user/wallet/check-and-deduct",
        {
          amount: unlockAmount, // Dynamic coin value
          campaign_id: ele?.campaign_id,
          campaign_name: ele?.campaign_title || "unknown campaign",
          brand_name: ele?.brand_name || "unknown brand",
        }
      );

      if (response?.data?.success) {
        onUnlockCampaign(ele?.campaign_id); // Optional if used
      } else {
        alert(response?.data?.message || "Unlock failed.");
      }
    } catch (error) {
      alert("Something went wrong while unlocking.");
      console.error(error);
    }
    fetchData();
  };

  return (
    <Card
      sx={{
        maxWidth: 320,
        minHeight: 530,
        borderRadius: 3,
        boxShadow: 3,
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Save Icon */}
      <Box
        sx={{
          position: "absolute",
          top: 25,
          right: 19,
          backgroundColor: "#fff",
          borderRadius: "50%",
          p: 0.5,
          zIndex: 2,
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleSaveCampaign(ele?.campaign_id);
        }}
      >
        <img
          src={savedCampaigns?.has(ele?.campaign_id) ? Savedark : Saveicon}
          alt="Save Icon"
          style={{ width: 20, height: 20, objectFit: "contain" }}
        />
      </Box>

      {/* Campaign Image */}
      <Box sx={{ p: 1.5, pt: 2, pb: 0 }}>
        <CardMedia
          component="img"
          height="170"
          image={ele?.campaign_poster || DummyImg}
          alt={ele?.campaign_title}
          sx={{
            width: "100%",
            objectFit: "cover",
            borderRadius: 2,
          }}
        />
      </Box>

      <CardContent sx={{ pb: 0 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight="600"
            noWrap
            sx={{ maxWidth: "60%", mt: 1 }}
          >
            {ele?.campaign_title}
          </Typography>

          {ele?.request_status === "Request Received" && (
            <Box
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: 500,
                color: "#fff",
                backgroundColor: "#6B8E76",
              }}
            >
              {ele.request_status}
            </Box>
          )}
        </Box>

        <Typography sx={{ fontFamily: "Poppins", mt: 2 }} noWrap>
          {ele?.brand_name}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={1}>
          <Calendar size={15} />
          <Typography
            noWrap
            sx={{
              fontFamily: "Poppins",
              fontSize: "14px",
              mb: 4,
            }}
          >
            {formatSingleDate(ele?.start_date)} -{" "}
            {formatSingleDate(ele?.end_date)}
          </Typography>
        </Stack>
      </CardContent>

      {/* Blur Bottom Section */}
      <Box
        sx={{
          position: "relative",
          background:
            "linear-gradient(180deg, rgba(107, 142, 118, 0) 0%, #6B8E76 100%)",
          px: 2,
          py: 3,
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
          overflow: "hidden",
        }}
      >
        <Box sx={{ textAlign: "center", mb: 1 }}>
          <img src={coin} alt="coin" />
        </Box>

        <Typography fontSize={14} fontWeight={600} textAlign="center">
          Unlock Exclusive Campaign Details
        </Typography>
        <Typography fontSize={14} textAlign="center" mt={5} mb={2}>
          Use your coins to view full brand info, deliverables & apply before
          spots run out.
        </Typography>

        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#F5ECFF",
            color: "rgba(107, 142, 118, 1)",
            fontWeight: 500,
            textTransform: "none",
            borderRadius: 2,
            boxShadow: "none",
          }}
          onClick={handleUnlockClick}
        >
          {ele?.budget > 500000
            ? "Use 500 Coins to Unlock"
            : ele?.budget > 300000
            ? "Use 200 Coins to Unlock"
            : ele?.budget > 100000
            ? "Use 100 Coins to Unlock"
            : "Use 20 Coins to Unlock"}
        </Button>
      </Box>
    </Card>
  );
};

export default CampaignCard;
